const SWITCH_BP = {
  '-switchBp-mobile':       399,
  '-switchBp-mobile-large': 767,
  '-switchBp-tablet':       990,
  '-switchBp-tablet-large': 1023,
  '-switchBp-desktop':      1199,
};

const gk_accordions = {
  load() {
    const blocks = document.querySelectorAll('.AccordionTabsBlock');
    blocks.forEach((block) => {
      if (block.dataset.gkInit) return;
      block.dataset.gkInit = '1';

      if (block.classList.contains('-modeAccordion')) {
        this.initAccordion(block);
      } else if (block.classList.contains('-modeTabs')) {
        this.initTabs(block);
      }
    });
  },

  /* =========================
     ACCORDION
  ========================== */
  initAccordion(block) {
    const multiOpen = block.dataset.multiOpen === '1';
    const items = block.querySelectorAll('.AccordionTabsBlock-item');

    // Measure real scrollHeight without being clipped by parent max-height: 0
    const measureHeight = (panel) => {
      const wasHidden = panel.hasAttribute('hidden');
      if (wasHidden) panel.removeAttribute('hidden');

      const prevMaxHeight = panel.style.maxHeight;
      panel.style.maxHeight = 'none';
      panel.style.visibility = 'hidden';

      const realHeight = panel.scrollHeight;

      panel.style.maxHeight = prevMaxHeight;
      panel.style.visibility = '';
      if (wasHidden) panel.setAttribute('hidden', '');

      return realHeight;
    };

    const openPanel = (trigger, panel) => {
      trigger.setAttribute('aria-expanded', 'true');
      panel.removeAttribute('hidden');
      const realHeight = measureHeight(panel);
      requestAnimationFrame(() => {
        panel.style.setProperty('--at-panel-height', realHeight + 'px');
      });
    };

    const closePanel = (trigger, panel) => {
      trigger.setAttribute('aria-expanded', 'false');
      panel.style.setProperty('--at-panel-height', '0px');
      setTimeout(() => {
        panel.setAttribute('hidden', '');
        panel.style.removeProperty('--at-panel-height');
      }, 400);
    };

    items.forEach((item) => {
      const trigger = item.querySelector('.AccordionTabsBlock-trigger');
      const panel   = item.querySelector('.AccordionTabsBlock-panel');
      if (!trigger || !panel) return;

      // Init open panels (first_open)
      if (trigger.getAttribute('aria-expanded') === 'true') {
        panel.removeAttribute('hidden');
        const realHeight = measureHeight(panel);
        panel.style.setProperty('--at-panel-height', realHeight + 'px');
      }

      trigger.addEventListener('click', () => {
        const isOpen = trigger.getAttribute('aria-expanded') === 'true';

        if (!multiOpen && !isOpen) {
          items.forEach((other) => {
            if (other === item) return;
            const otherTrigger = other.querySelector('.AccordionTabsBlock-trigger');
            const otherPanel   = other.querySelector('.AccordionTabsBlock-panel');
            if (otherTrigger && otherPanel && otherTrigger.getAttribute('aria-expanded') === 'true') {
              closePanel(otherTrigger, otherPanel);
            }
          });
        }

        if (isOpen) {
          closePanel(trigger, panel);
        } else {
          openPanel(trigger, panel);
        }
      });
    });

    // Recalculate when images inside panels load
    const images = block.querySelectorAll('.AccordionTabsBlock-content img');
    images.forEach((img) => {
      if (img.complete) return;
      img.addEventListener('load', () => {
        const item    = img.closest('.AccordionTabsBlock-item');
        const trigger = item?.querySelector('.AccordionTabsBlock-trigger');
        const panel   = item?.querySelector('.AccordionTabsBlock-panel');
        if (trigger?.getAttribute('aria-expanded') === 'true' && panel) {
          const realHeight = measureHeight(panel);
          panel.style.setProperty('--at-panel-height', realHeight + 'px');
        }
      });
    });
  },

  /* =========================
     TABS (vanilla)
  ========================== */
  initTabs(block) {
    const tabs   = Array.from(block.querySelectorAll('.AccordionTabsBlock-tab'));
    const panels = Array.from(block.querySelectorAll('.AccordionTabsBlock-panel'));

    if (!tabs.length || !panels.length) return;

    const switchClass = Array.from(block.classList).find((c) => c.startsWith('-switchBp-'));
    const switchPx    = SWITCH_BP[switchClass] ?? 767;

    const activateTab = (targetTab, { focus = true } = {}) => {
      const targetId = targetTab.getAttribute('aria-controls');

      tabs.forEach((tab) => {
        const isTarget = tab === targetTab;
        tab.setAttribute('aria-selected', isTarget ? 'true' : 'false');
        tab.setAttribute('tabindex', isTarget ? '0' : '-1');
        tab.classList.toggle('is-active', isTarget);
      });

      panels.forEach((panel) => {
        const isTarget = panel.id === targetId;
        if (isTarget) {
          panel.removeAttribute('hidden');
          panel.classList.add('is-active');
        } else {
          panel.setAttribute('hidden', '');
          panel.classList.remove('is-active');
        }
      });

      if (focus) targetTab.focus();

      // Scroll to panel when tabs are stacked below switch breakpoint
      if (window.innerWidth <= switchPx) {
        setTimeout(() => {
          const activePanel = block.querySelector('.AccordionTabsBlock-panel:not([hidden])');
          if (!activePanel) return;

          const header = document.querySelector('.SiteHeader, header[role="banner"]');
          const headerHeight = header ? header.offsetHeight : 80;
          const targetTop = activePanel.getBoundingClientRect().top + window.scrollY - headerHeight - 20;

          window.scrollTo({ top: targetTop, behavior: 'smooth' });
        }, 100);
      }
    };

    const selected = tabs.find((t) => t.getAttribute('aria-selected') === 'true');
    activateTab(selected || tabs[0], { focus: false });

    const tablist = block.querySelector('.AccordionTabsBlock-tabsList');
    if (tablist) {
      tablist.addEventListener('click', (e) => {
        const tab = e.target.closest('.AccordionTabsBlock-tab');
        if (!tab) return;
        e.preventDefault();
        activateTab(tab);
      });

      tablist.addEventListener('keydown', (e) => {
        const current = e.target.closest('.AccordionTabsBlock-tab');
        if (!current) return;
        const idx = tabs.indexOf(current);
        if (idx < 0) return;

        let nextIdx = null;

        switch (e.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            nextIdx = (idx + 1) % tabs.length;
            break;
          case 'ArrowLeft':
          case 'ArrowUp':
            nextIdx = (idx - 1 + tabs.length) % tabs.length;
            break;
          case 'Home':
            nextIdx = 0;
            break;
          case 'End':
            nextIdx = tabs.length - 1;
            break;
          default:
            return;
        }

        e.preventDefault();
        activateTab(tabs[nextIdx]);
      });
    }
  },
};

export default gk_accordions;
